import { Injectable } from '@angular/core';
import { DataCacheService } from './data-cache.service';
import { EntitlementsAndSubscriptionReleaseDate } from 'utils';
@Injectable({
  providedIn: 'root',
})
export class DepreciatedService {
  constructor(private dataCacheService: DataCacheService) {}
  account = this.dataCacheService.getCachedValues('account');
  deprecatedResourcesInUse = this.dataCacheService.getCachedValues(
    'deprecated-resources-in-use'
  );
  get hideProperty(): boolean {
    if (this.account && this.account?.createdAt) {
      const accountCreatedAt = new Date(this.account.createdAt);
      return accountCreatedAt > EntitlementsAndSubscriptionReleaseDate;
    }
    return false;
  }
  /**
   * Hide product version if it is not in use
   */
  get isProductVersionHidden(): boolean {
    const productVersions = this.deprecatedResourcesInUse?.productVersions;
    return this.hideProperty || !(productVersions && productVersions > 0);
  }
}
